module.exports = __webpack_public_path__ + "media/images/app/occasions/everyday-7b30da74c77af80720086ed5b7864fe0.webp";